"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailVerificationState = void 0;
var EmailVerificationState;
(function (EmailVerificationState) {
    EmailVerificationState["VERIFIED"] = "VERIFIED";
    EmailVerificationState["UNVERIFIED"] = "UNVERIFIED";
    EmailVerificationState["UNKNOWN"] = "UNKNOWN";
    EmailVerificationState["INVALID"] = "INVALID";
})(EmailVerificationState || (exports.EmailVerificationState = EmailVerificationState = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aGVudGljYXRpb24tdHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvYXV0aGVudGljYXRpb24tdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBK0VBLElBQVksc0JBS1g7QUFMRCxXQUFZLHNCQUFzQjtJQUNoQywrQ0FBcUIsQ0FBQTtJQUNyQixtREFBeUIsQ0FBQTtJQUN6Qiw2Q0FBbUIsQ0FBQTtJQUNuQiw2Q0FBbUIsQ0FBQTtBQUNyQixDQUFDLEVBTFcsc0JBQXNCLHNDQUF0QixzQkFBc0IsUUFLakMifQ==